import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockItemActivity'), ...new Mutations('stockItemActivities') };
